// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-check input[type=checkbox].risk-low + label {\n  color: green;\n}\n\n.form-check input[type=checkbox].risk-medium + label {\n  color: orange;\n}\n\n.form-check input[type=checkbox].risk-high + label {\n  color: red;\n}", ""]);
// Exports
module.exports = exports;
